var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.state)?_c('div',{staticClass:"filter-item pointable w-44 refresh",class:_vm.cls,on:{"click":function($event){return _vm.refresh()}}},[_c('i',{staticClass:"fas fa-redo"}),_c('div',{staticClass:"timer"},[_vm._v(_vm._s(_vm.counter))])]):_c('div',{staticClass:"filter-item w-44",class:_vm.cls},[_c('i',{staticClass:"fad fa-spinner fa-spin"})])
}
var staticRenderFns = []

export { render, staticRenderFns }